/*
  Content questions store the HTML produced by the admin rich text editor. That
  HTML crosses the API before reaching a customer-facing page, so it is never
  trusted: everything outside the allowlist below is unwrapped (keeping its
  text) or dropped, and every attribute is stripped, which removes event
  handlers, inline styles and any href/src target.
*/

const ALLOWED_TAGS = new Set([
    "P",
    "BR",
    "STRONG",
    "B",
    "EM",
    "I",
    "U",
    "S",
    "STRIKE",
    "DEL",
    "CODE",
    "PRE",
    "BLOCKQUOTE",
    "UL",
    "OL",
    "LI",
    "H1",
    "H2",
    "H3",
    "H4",
    "H5",
    "H6",
    "HR",
]);

// Unwrapping these would leak their contents as visible text, so they go away
// entirely along with their children.
const DROPPED_TAGS = new Set([
    "SCRIPT",
    "STYLE",
    "IFRAME",
    "OBJECT",
    "EMBED",
    "LINK",
    "META",
    "TITLE",
    "BASE",
    "NOSCRIPT",
    "TEMPLATE",
    "SVG",
    "MATH",
    "FORM",
    "INPUT",
    "BUTTON",
    "TEXTAREA",
    "SELECT",
]);

function clean(node) {
    Array.from(node.childNodes).forEach((child) => {
        if (child.nodeType === 3) {
            return;
        }
        if (child.nodeType !== 1) {
            child.remove();
            return;
        }

        const tag = child.tagName.toUpperCase();

        if (DROPPED_TAGS.has(tag)) {
            child.remove();
            return;
        }

        if (!ALLOWED_TAGS.has(tag)) {
            clean(child);
            const parent = child.parentNode;
            while (child.firstChild) {
                parent.insertBefore(child.firstChild, child);
            }
            child.remove();
            return;
        }

        Array.from(child.attributes).forEach((attribute) => {
            child.removeAttribute(attribute.name);
        });
        clean(child);
    });
}

export function sanitizeRichText(html) {
    if (!html) {
        return "";
    }

    // DOMParser does not run scripts or load resources while parsing.
    const parsed = new DOMParser().parseFromString(String(html), "text/html");
    clean(parsed.body);
    return parsed.body.innerHTML;
}

export default sanitizeRichText;
